import * as styles from "./index.module.scss";
import { BannerPopupProps, CtaBanner } from "./types";
import { GeneralMediumClose } from "@wise-emotions/react-icons";
import { navigate } from "gatsby";
import { useSiteContext } from "context/SiteProvider";
import Cookies from "js-cookie";
import Image from "components/Image";
import React, { useEffect, useState } from "react";
import cn from "classnames";

const BannerPopup = ({ ctaBanner, slug, image }: BannerPopupProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const { state } = useSiteContext();
  const cookieSlug = `b-popup-${slug}`;

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!Cookies.get(cookieSlug) && state?.scriptCookieGtm) {
        setIsVisible(true);
      }
    }, 4000);
    return () => clearTimeout(timer);
  }, [state?.scriptCookieGtm, cookieSlug]);

  const setCookie = () => {
    Cookies.set(cookieSlug, "true", { expires: 7 });
  };

  const closeBanner = () => {
    setIsVisible(false);
    setCookie();
  };

  const cta = (ctaB: CtaBanner) => {
    setCookie();

    if (ctaB.targetBlank) {
      const a = document.createElement("a");
      a.target = "_blank";
      a.href = ctaB.url;
      a.click();
    } else {
      navigate(ctaB.url);
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isVisible && !open) {
      timer = setTimeout(() => {
        setOpen(true);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [isVisible, open]);

  return isVisible ? (
    <div
      className={cn(styles.bannerPopup, {
        [styles.bannerPopupOpen]: open,
      })}
      data-module="banner-popup"
      data-label={slug}
      data-action="banner-view"
    >
      <button
        // TODO add correct aria label ( not hardcoded value )
        aria-label="Chiudi banner"
        className={styles.bannerPopup__close}
        onClick={() => closeBanner()}
        type="button"
        data-action="banner-click-close"
      >
        <GeneralMediumClose />
      </button>
      <div className={styles.bannerPopup__image}>
        <Image {...image} />
      </div>

      <input
        // TODO add correct aria label ( not hardcoded value )
        aria-label="chiudi"
        className={styles.bannerPopup__cta}
        type="button"
        onClick={() => cta(ctaBanner)}
        data-tracking={ctaBanner.dataTracking}
        data-action="banner-click-cta"
      />
    </div>
  ) : null;
};

export default BannerPopup;
